import { Base64 }   from 'js-base64';
import React        from 'react';
import { connect }  from 'react-redux';

import { Wrappers, WrapperKeys } from '../../models/AARPWrappers';
import styles from './AARPWrapper.css';

type AARPWrapperComponentBaseProps = {
    wrappers: Wrappers;
    wrapperKey: any;
};

interface RootState {
    wrappers: Wrappers;
}

interface RouteComponentProps{
    wrapperKey: any;
}

class AARPWrapperComponentBase extends React.Component<AARPWrapperComponentBaseProps> {
    static displayName = 'AARPWrapperComponent';

    shouldComponentUpdate() {
        return false;
    }

    render() {
        const { wrappers, wrapperKey } = this.props;

        if (!wrapperKey || !wrappers[wrapperKey]) {
            console.warn(`AARPWrapperComponent: wrapper key was not provided or wrapper for key "${wrapperKey}" does not exist`);
            return null;
        }

        const wrapper = Base64.decode(wrappers[wrapperKey]);

        return (
            <Container
                dangerouslySetInnerHTML={{__html: wrapper}}
            />
        );
    }
}

const Container = (props: any) => <div className = {styles.container} {...props} />;

export const AARPWrapperComponent = connect(
    (state: RootState, props: RouteComponentProps) => ({
        wrappers: state.wrappers,
        wrapperKey: props.wrapperKey,
    }),
)(AARPWrapperComponentBase);
